module.exports = __webpack_public_path__ + "media/scripts/pages/csr/assets/media/images/Stills_3_Bakgia-648e0286feab41b105ceb7f4d004dbc2.jpg";